import {computed, defineComponent, ref} from 'vue';
import {validate} from 'email-validator';
import {CourseServices} from '@/services/course/CourseServices';
import type {AxiosError} from "axios";

export default defineComponent({
    name: 'Subscription',
    setup() {
        let email = ref<string>('')
        let agree = ref([])
        let emailSent = ref<boolean>(false)
        let error = ref(false)
        let errorMsg = ref('')
        let subscribing = ref(false)

        const isButtonDisabled = computed(() => {
            return agree.value.length === 0 || email.value.length < 4
        })

        const subscribe = async () => {
            if (subscribing.value) {
                return
            }
            if (validate(email.value)) {
                subscribing.value = true
                await CourseServices.subscriptionEmail(email.value)
                    .then(res => {
                        console.log("response: ", res)
                        emailSent.value = true
                        setTimeout(() => {
                            email.value = ''
                            agree.value = []
                            emailSent.value = false
                        }, 5000)

                    }).catch((err: AxiosError) => {
                        console.log(err.response?.data.message)
                        error.value = true
                        errorMsg.value = err.response?.data.message
                    })
                    .finally(() => {
                        subscribing.value = false
                    })
            } else {
                emailSent.value = false
                error.value = true
                errorMsg.value = 'Email address is not valid'
            }
        }

        return {
            email,
            emailSent,
            agree,
            isButtonDisabled,
            subscribe,
            subscribing,
            error,
            errorMsg
        }
    }
})
